import {
  MODEL_ID,
  PROVIDER,
  ACTION,
  MODE,
  MATERIAL,
  POLYGON_TYPE,
  MODEL_FORMAT_OUTPUT,
} from 'Pods/ThreeDStudio/Store/constants'

export default {
  "model_id": MODEL_ID.TRIPO3D_TEXT_TO_3D_DEFAULT,
  "provider": PROVIDER.TRIPO3D,
  "action": ACTION.TEXT_TO_3D,
  "mode": MODE.NORMAL,
  "input_schema": {
    "type": "object",
    "properties": {
      "prompt": {
        "type": "string",
        "minLength": 1,
        "maxLength": 1024,
      },
      "material": {
        "type": "string",
        "enum": [MATERIAL.GEOMETRY_ONLY, MATERIAL.BASIC, MATERIAL.PBR],
        "default": MATERIAL.BASIC,
      },
      "face_count": {
        "type": "integer",
        "oneOf": [
          {
            "if": {
              "properties": { "polygon_type": { "const": POLYGON_TYPE.TRIANGLE } },
              "required": ["polygon_type"],
            },
            "then": {
              "properties": {
                "face_count": { "minimum": 10000, "maximum": 1000000, "default": 100000 },
              },
            },
          },
          {
            "if": {
              "properties": { "polygon_type": { "const": POLYGON_TYPE.QUADRILATERAL } },
              "required": ["polygon_type"],
            },
            "then": {
              "properties": {
                "face_count": { "minimum": 10000, "maximum": 150000, "default": 100000 },
              },
            },
          },
        ],
      },
      "polygon_type": {
        "type": "string",
        "enum": [POLYGON_TYPE.TRIANGLE, POLYGON_TYPE.QUADRILATERAL],
        "default": POLYGON_TYPE.QUADRILATERAL,
      },
      "smart_low_poly": {
        "type": "boolean",
        "default": false,
      },
    },
    "required": ["prompt"],
    "allOf": [
      {
        "if": {
          "properties": {
            "material": { "enum": [MATERIAL.BASIC, MATERIAL.GEOMETRY_ONLY, MATERIAL.PBR] },
          },
          "required": ["material"],
        },
        "then": false,
      },
      {
        "if": {
          "properties": { "material": { "const": MATERIAL.GEOMETRY_ONLY } },
          "required": ["material"],
        },
        "then": {
          "properties": {
            "texture": { "const": false },
            "pbr": { "const": false },
            "material_mode": { "const": 'none' },
          },
        },
      },
      {
        "if": {
          "properties": { "material": { "const": MATERIAL.BASIC } },
          "required": ["material"],
        },
        "then": {
          "properties": {
            "material_mode": { "const": 'shaded' },
          },
        },
      },
      {
        "if": {
          "properties": { "material": { "const": MATERIAL.PBR } },
          "required": ["material"],
        },
        "then": {
          "properties": {
            "material_mode": { "const": 'PBR' },
          },
        },
      },
      {
        "if": {
          "properties": { "polygon_type": { "const": POLYGON_TYPE.TRIANGLE } },
          "required": ["polygon_type"],
        },
        "then": {
          "properties": {
            "model_format_output": { "const": MODEL_FORMAT_OUTPUT.GLB },
            "generate_type": { "const": 'Normal' },
          },
        },
      },
      {
        "if": {
          "properties": { "polygon_type": { "const": POLYGON_TYPE.QUADRILATERAL } },
          "required": ["polygon_type"],
        },
        "then": {
          "properties": {
            "model_format_output": { "const": MODEL_FORMAT_OUTPUT.FBX },
            "generate_type": { "const": 'Normal' },
          },
        },
      },
      {
        "if": {
          "properties": { "smart_low_poly": { "const": true } },
          "required": ["smart_low_poly"],
        },
        "then": {
          "properties": {
            "generate_type": { "const": 'LowPoly' },
            "material_mode": false,
            "face_count": false,
            "polygon_type": false,
            "texture": false,
            "pbr": false,
          },
        },
      },
      {
        "if": {
          "properties": { "smart_low_poly": { "const": false } },
          "required": ["smart_low_poly"],
        },
        "then": false,
      },
    ],
  },
  "ui_schema": {},
  "active_if": {},
  "keyToConvert": [
    { "from": "face_count", "to": "polycount" },
    { "from": "polygon_type", "to": "topology" },
  ],
}
